module.exports = __webpack_public_path__ + "static/home-background-bf51921fb49060b63e2b55eb4d2ea948.webp";